import { render, staticRenderFns } from "./ChangePropertyLocationModal.vue?vue&type=template&id=5cc5ec25&"
import script from "./ChangePropertyLocationModal.vue?vue&type=script&lang=ts&"
export * from "./ChangePropertyLocationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports